<div [id]="buttonId" [class]="'hb-container hb-status-' + buttonStatus + ' hb-container-' + size" kenjoHoldable (holdTime)="holdHandler($event)" [ngClass]="{ 'hb-container-disabled': disabled }">
  <mat-progress-spinner mode="determinate" color="#FFFFFF" [value]="progress" [diameter]="30" [strokeWidth]="2"></mat-progress-spinner>
  <kenjo-icon [size]="15" class="kenjo-font-color-white-ffffff">check_out</kenjo-icon>
  <div class="kenjo-font-size-16px kenjo-ml-10px hb-title">{{ title }}</div>
</div>
